<template>
  <div class="task taskButton">
    <button v-on:click="doTask()" type="button" class="w3-buttonTask">
      <transition name="fade" mode="out-in">
        <spinner-loading v-if="taskLoading" class="spinner-loading" :line-size='2' :size='18' line-fg-color='#5dbecd' />
        <i v-else :class="['sherpa-icon', 'icon-' + task.taskId]"></i>
      </transition>
      <span>{{ task.label }}</span>
    </button>
    <div class="message">
      <transition name="fade" mode="out-in">
        <span v-if="!taskLoading && taskError" class="label error_validate"> {{ taskResp }} </span>
        <span v-else-if="!taskLoading && taskResp && taskResp !== ''" class="label ok_validate"> {{ taskResp }} </span>
      </transition>
    </div>
  </div>
</template>

<script>
import * as api from '../../utils/definitionApi'
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue'
import language from '../../language'

export default {
  name: 'definition-task-button',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'repeatableItemIndex',
    'calledTaskIndex',
    'callTask'
  ],
  data () {
    return {
      taskError: false,
      taskResp: '',
      taskLoading: false
    }
  },
  components: {
    SpinnerLoading
  },
  methods: {
    doTask () {
      if (this.task.persist) {
        // Dialog
        let message = this.task.info
        let options = {
          okText: this.$ml.get('yes'),
          cancelText: this.$ml.get('cancel'),
          customClass: 'sherpaDialog'
        }
        this.$dialog.confirm(message, options)
          .then(() => {
            this.callTaskService()
          })
          .catch(() => {
          })
      } else {
        this.callTaskService()
      }
    },
    callTaskService () {
      this.taskLoading = true
      setTimeout(() => {
        api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode, requestObject: this.object }})
          .then(resp => {
            this.taskError = false
            this.taskLoading = false

            let message
            if (this.task.persist) {
              if (resp.requestResult) {
                message = resp.requestResultSuccess
              } else {
                message = resp.requestResultError.requestErrorMsg
              }
            } else {
              if (resp.requestResultSuccess) {
                this.taskResp = resp.requestResultSuccess
              } else if (resp.requestResultError) {
                this.taskError = true
                if (resp.requestResultError.requestErrorType === 'VALIDATION') {
                  this.taskResp = this.getLang('errorTaskValidation')
                } else {
                  if (resp.requestResultError.requestErrorMsg) {
                    this.taskResp = resp.requestResultError.requestErrorMsg
                  } else {
                    this.taskResp = this.getLang('taskError')
                  }
                }
              }
              message = this.taskResp
            }
            this.doTaskEnd(resp, message)
          })
          .catch(err => {
            console.log(err)
            this.taskError = true
            this.taskLoading = false
          })
      }, 500)
    },
    getLang (key) {
      return language(this.language, key)
    },
    doTaskEnd (resp, message) {
      if (resp.requestResult) {
        if (this.task.menuId) {
          if (this.task.menuId === 'open_new_window') {
            window.open(resp.requestObjectId)
            this.$emit('refreshDefinitionContent')
          } else if (this.$route.name === this.task.menuId) {
            this.$emit('refreshDefinitionContent')
          } else {
            this.$router.push({name: this.task.menuId, params: { id: this.definitionContentId }}).catch(() => {})
          }
        } else if (resp.requestObject) {
          this.$emit('refreshDefinition', resp.requestObject, this.task.scope)
        }
      }
      this.$emit('taskEnded', {taskId: this.task.taskId, resp, message: message})
    }
  },
  watch: {
    calledTaskIndex: {
      handler: function (val) {
        this.callTaskService()
      },
      deep: true
    },
    callTask: {
      handler: function (val) {
        if (val.id === this.task.taskId) {
          this.callTaskService()
        }
      },
      deep: true
    }
  }
}
</script>
